import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <div className="App bg-[#0A0A0A] text-[#FFFFF0] min-h-screen grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#141414",
            border: "1px solid rgba(212, 175, 55, 0.3)",
            color: "#FFFFF0",
          },
        }}
      />
    </div>
  );
}

export default App;
